<article class="cart-item-card">
  <div class="top-row">
    <img [src]="item.imageUrl" [alt]="item.title" />
    <div class="item-info">
      <h3>{{ item.title }}</h3>
      <p class="price">{{ item.price | currency:'USD':'symbol':'1.0-0' }}</p>
      <p class="variant">{{ item.variant }}</p>
    </div>
    <button type="button" class="delete-btn" (click)="remove.emit()" aria-label="Remove item">
      <i class="pi pi-trash"></i>
    </button>
  </div>

  <div class="bottom-row">
    <button type="button" class="favorite-btn" (click)="addToFavorite.emit()">
      <i class="pi pi-heart"></i>
      <span>{{ 'APP.CART_ADD_TO_FAVORITE' | translate }}</span>
    </button>

    <app-quantity-selector
      [value]="item.quantity"
      (increment)="incrementQty.emit()"
      (decrement)="decrementQty.emit()"
    ></app-quantity-selector>
  </div>
</article>
